import { ReactElement } from "react";
import * as styles from "./FileDetail.module.scss";
import { closeIcon } from "../../../Icons";

interface IFileDetailProps {
    file: File;
    onRemoveFile: (file: File) => void;
}

function getFileSize(sizeInBytes: number) {
    const kilobyte = 1024;
    const megabyte = 1048576;

    if (sizeInBytes < kilobyte) return `${sizeInBytes} B`;
    if (sizeInBytes < megabyte) return `${(sizeInBytes / kilobyte).toFixed(0)} KB`;

    return `${(sizeInBytes / megabyte).toFixed(2)} MB`;
}

export default function FileDetail({ file, onRemoveFile }: IFileDetailProps): ReactElement {
    return (
        <div className={styles.fileItem}>
            <span>
                {file.name}({getFileSize(file.size)})
            </span>
            <button onClick={() => onRemoveFile(file)} type="button">
                {closeIcon}
            </button>
        </div>
    );
}
